export default __webpack_public_path__ + "static/media/hellometer_text_white.06156bf0.png";